import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import supabase from '../../../../supabaseClient';

const LessonDetail = () => {
  const { lessonId } = useParams();
  const [lesson, setLesson] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchLesson = async () => {
      setLoading(true);
      const { data, error } = await supabase
        .from('academy_lessons')
        .select('*')
        .eq('id', lessonId)
        .single();
      if (error) setError(error.message);
      else setLesson(data);
      setLoading(false);
    };
    fetchLesson();
  }, [lessonId]);

  if (loading) return <div>Loading lesson...</div>;
  if (error) return <div>Error: {error}</div>;
  if (!lesson) return <div>Lesson not found.</div>;

  return (
    <div className="academy-page-shell lesson-detail-page">
      <div className="lesson-detail">
        <h2>{lesson.title}</h2>
        <p>{lesson.description}</p>
        <button className="btn-copy-link" onClick={() => navigator.clipboard.writeText(window.location.href)}>
          Copy Link
        </button>
      </div>
    </div>
  );
};

export default LessonDetail;
